<template>
  <div class="container">
    <div class="map-list-item stop row" @click="itemClicked" :title="this.entryData.nimi">
      <div class='state col-1'>
        <svg height="1.2em" width="1.2em">
          <circle preserveAspectRatio="xMidYMid meet" cx="50%" cy="50%" r="4.3" 
                :stroke="iconColors[this.type].stroke"
                stroke-width="1"
                :fill="iconColors[this.type].fill"
                fill-opacity="0.7"
                />
        </svg>
      </div>
      <div class='id col-1'>{{ this.entryData.sms }}</div> 
      <div class='name col'>{{ this.nimi }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapStopEntry',
  props: {
   entry: {type: Object}
  },
  data: function() {
    return {
      entryData: null,
      defaultData: {tunnus:"-", nimi:"-", type:"normal"},
      iconColors: {
        normal: {
          stroke: "#20376C",
          fill: "#4C82ff"
        },
        on_demand: {
          stroke: "#5e3473",
          fill: "#ad60d3"
        },
        tram: {
          fill : "#C8C800",
          stroke : "#878700",
        },
      }
      /*icons: {
        normal: '/traveller-ui/map/images/icons/pysakki_green_plain.svg',
        on_demand: '/traveller-ui/map/images/icons/pysakki_purple_plain.svg',
      }*/
    }
  },
  created() {
    this.entryData = Object.assign(this.defaultData,this.entry);
  },
  computed: {
    nimi: function() {
      /*
      if(this.entryData.nimi != null && this.entryData.nimi.length > 1) {
        return this.entryData.nimi;
      } else {
        return this.entryData.tunnus;
      }
      */
      /*if(this.entryData.nimi.length <= 13) {
        return this.entryData.nimi;
      } else {
        return this.entryData.nimi.substring(0,12) + "...";
      }*/
      return this.entryData.nimi;

    },
    tunnus: function() {
      return this.entryData.tunnus.substring(0,8);
    },
    type: function() {
      try{
        if(this.entryData.stopFeatures.ON_DEMAND == 'true')
          return 'on_demand';
        else if(this.entryData.stopFeatures.LINE_TYPE == '0')
          return 'tram';
        else
          return 'normal';

      } catch(err) {
        return 'normal';
      }
    }
  },
  methods: {
    itemClicked() {
      this.$emit('click', this.entryData.tunnus);
    }
  }
}
</script>


 <style scoped lang="scss"> 

div[class="name col"] {
  display: inline-block;
  height: 100%;
  margin-left: 4em;
}
div[class="id col-1"] {
  display: inline-block;
  height: 100%;
  font-size: 90%;
  padding-right: 1em;

}


</style> 
